// Import dependencies
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import VisitorAPI from 'visitorapi';
import * as notif_helpers from '../../../helpers/Notifications.js';

// Import CSS
import './Promoteur.css';

// Import components
import Navbar_Simple from '../../../components/landing/navbar/Navbar_Simple';
import Header_Promoteur from '../../../components/landing/header/Header_Promoteur';
import VideoDemo from '../../../components/landing/video_demo/VideoDemo';
import Solution_Promoteur from '../../../components/landing/solution/Solution_Promoteur';
import Features_Promoteur from '../../../components/landing/features/Features_Promoteur';
import Steps from '../../../components/landing/steps/Steps';
import CTA_Promoteur from '../../../components/landing/cta/CTA_Promoteur';
import Contact from '../../../components/landing/contact/Contact';
import Footer from '../../../components/landing/footer/Footer';
import Partners from '../../../components/landing/partners/Partners';


const Promoteur = () => {

    // Set hooks
    const [toggleFullSizeGeneral, setToggleFullSizeGeneral] = useState(false);
    const [contactGlowing, setContactGlowing] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();

    function getOrigin() {
        var origin = searchParams.get("origin");
        if (!origin) {
            origin = searchParams.get("utm_source");
        }
        return origin;
    }

    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    const trackVisitors = () => {
        var txt_origin = getOrigin() ? ("\nCanal : " + getOrigin()) : "";
        VisitorAPI("QATBzQzbKVko4oC7b7PF").then(data => {
            // console.log("VISITOR API", data);
            var txt_location = (data?.city && data?.countryName) ? ("\nLocalisation : " + capitalizeFirstLetter(data.city) + (data?.region ? (", " + (data.region).toUpperCase()) : "") + ", " + capitalizeFirstLetter(data.countryName)) : "";
            var txt_device = (data?.deviceFamily && data?.os) ? ("\nDevice : " + data.deviceFamily + " (" + data.os + ")") : "";
            var txt_browser = (data?.browser) ? ("\nBrowser : " + data.browser + (data?.browserVersion ? (" (" + data.browserVersion + ")") : "")) : "";
            // Send notif
            notif_helpers.sendPushoverNotification("Proplab - Nouveau visiteur", "Page : Landing Promoteur" + txt_origin + txt_location + txt_device + txt_browser);
        }).catch(error => {
            notif_helpers.sendPushoverNotification("Proplab - Nouveau visiteur", "Page : Landing Promoteur" + txt_origin);
            // handle error
        });
    }

    useEffect(() => {
        trackVisitors();
    }, []);

    // Check if user is using mobile app
    return (
        <div className='landing__home'>
            <Navbar_Simple origin={getOrigin()} toggleFullSizeGeneral={toggleFullSizeGeneral} />
            <Header_Promoteur origin={getOrigin()} setToggleFullSizeGeneral={setToggleFullSizeGeneral} setContactGlowing={setContactGlowing} />
            <VideoDemo />
            <Steps />
            <Solution_Promoteur />
            <div className="app__sectiondata_widget_spacer_6rem"></div>
            <Partners />
            <div className="app__sectiondata_widget_spacer_6rem"></div>
            <Features_Promoteur />
            <CTA_Promoteur origin={getOrigin()} setToggleFullSizeGeneral={setToggleFullSizeGeneral} setContactGlowing={setContactGlowing} />
            <Contact origin={getOrigin()} glowingLaunch={contactGlowing} setContactGlowing={setContactGlowing} />
            <Footer origin={getOrigin()} />
        </div>
    );
};

export default Promoteur;